// extracted by mini-css-extract-plugin
export var chevron = "_r4-1";
export var clickable = "_r4-0";
export var ruleRow = "_r4-2";